import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'
import { CURTAIN_ANIMATION_IN_SECONDS } from 'constants.js'

const bannerAnimation = CURTAIN_ANIMATION_IN_SECONDS + 0.5

export default makeStyles((theme: Theme) => ({
    '@keyframes fadeInBanner': {
        from: {},
        to: {
            opacity: 1,
        },
    },
    fullHeight: {},
    closedState: {},
    curtainOpen: {},
    curtainContainer: {
        position: 'absolute',
        bottom: 0,
        overflow: 'hidden',
        height: 0,
        transition: `${CURTAIN_ANIMATION_IN_SECONDS}s ease-out`,
        zIndex: 1,
        boxSizing: 'border-box',
        backgroundColor: theme.colors.dark.dark1,
        color: theme.colors.white,
        '@media (min-width: 768px)': {
            width: 'calc(100% - 32px)',
        },
        '@media (max-width: 767px)': {
            width: '100%',
        },
        '&$curtainOpen': {
            position: 'absolute',
            right: 16,
            height: 0,
            transition: `${CURTAIN_ANIMATION_IN_SECONDS}s ease-in`,

            '@media (max-width: 767px)': {
                right: 0,
            },
        },
        '&$fullHeight': {
            height: '100%',
        },
        '&$closedState': {
            overflow: 'visible',
            transition: 'none',
            width: 'auto',
            position: 'relative',
            bottom: 0,
            top: 0,
        },
    },
    startAnimatingBanner: {},
    curtainBanner: {
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',

        '&$startAnimatingBanner': {
            opacity: 0,
            animation: `$fadeInBanner ${bannerAnimation}s forwards ${bannerAnimation}s`,

            '@media (min-width: 768px)': {
                backgroundColor: theme.colors.dark.dark4,
            },
        },
    },
    bannerMessage: {
        margin: '40px 16px',
        flex: 1,

        '@media (min-width: 1024px)': {
            margin: '78px 40px',
        },
    },
    heading: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 10,
        color: theme.colors.brand.yellow,
        marginBottom: 5,
        textTransform: 'uppercase',
        '@media (min-width: 1440px)': {
            fontSize: 13,
        },
        '@media (min-width: 1600px)': {
            fontSize: 16,
        },
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 20,
        marginBottom: 5,
        '@media (min-width: 1024px)': {
            fontSize: 30,
        },
        '@media (min-width: 1200px)': {
            fontSize: 35,
        },
        '@media (min-width: 1440px)': {
            fontSize: 40,
        },
        '@media (min-width: 1600px)': {
            fontSize: 45,
        },
    },
    message: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: 12,
        opacity: 0.8,
        '@media (min-width: 1024px)': {
            width: '90%',
        },
        '@media (min-width: 1200px)': {
            fontSize: 15,
            width: '75%',
        },
        '@media (min-width: 1600px)': {
            fontSize: 18,
            width: '70%',
        },
    },
    artistPic: {
        display: 'none',
        '@media (min-width: 1200px)': {
            display: 'block',
            height: 300,
        },
    },
}))
